import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class ClientService {
  getallClient(data) {
    return axios.get(serverURL + "/client-api?req=smarttableClient", {
      params: data,
      headers: headeroption,
    })
  }
  getClient(client_id) {
    return axios.get(serverURL + "/client-api?req=getClient", {
      params: { client_id: client_id }, headers: headeroption,
    });
  }
  createClient(data) {
    return axios.post(serverURL + "/client-api?req=createClient", data, {
      headers: headeroption,
    });
  }
  updateClient(data) {
    return axios.put(serverURL + "/client-api?req=updateClient", data, {
      headers: headeroption,
    });
  }
  deleteClient(client_id) {
    return axios.delete(serverURL + "/client-api?req=deleteClient", { params: { client_id: client_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/client-api?req=deleteClient");
  }
  findByTitle(client_name) {
    return axios.get(serverURL + "/client/client-api?name=" + client_name);
  }
  upload(client_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?client_id=" + client_id, data, { headers: headeroptionupload });
  }
  uploads(client_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?client_id=" + client_id, data, { headers: headeroptionupload });
  }
}
export default new ClientService();
